import {Action, ActionReducer} from '@ngrx/store';
import * as PtCoreActions from '../store/actions/pt-core.actions';

export function clearStateReducer(reducer: ActionReducer<unknown>): ActionReducer<unknown> {
  return (state, action: Action) => {
    if (action.type === PtCoreActions.logoutAndClearData.type) {
      state = undefined;
    }
    if (action.type === PtCoreActions.logoutAndClearDataForInactivityTime.type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}
